// src/services/userService.js
import { 
  collection, 
  doc, 
  getDoc, 
  setDoc, 
  updateDoc, 
  query, 
  where, 
  getDocs,
  serverTimestamp 
} from 'firebase/firestore';
import { db } from '../firebase';

const USERS_COLLECTION = 'payback-users';

export const userService = {
  /**
   * Create or update user profile
   */
  async saveUser(userId, userData) {
    try {
      const userRef = doc(db, USERS_COLLECTION, userId);
      await setDoc(userRef, {
        ...userData,
        updatedAt: serverTimestamp()
      }, { merge: true });
      return { success: true, id: userId };
    } catch (error) {
      console.error('Error saving user:', error);
      throw error;
    }
  },

  /**
   * Get user by ID
   */
  async getUser(userId) {
    try {
      const userRef = doc(db, USERS_COLLECTION, userId);
      const userSnap = await getDoc(userRef);
      
      if (userSnap.exists()) {
        return { ...userSnap.data(), id: userSnap.id };
      }
      return null;
    } catch (error) {
      console.error('Error getting user:', error);
      throw error;
    }
  },

  /**
   * Get user by mobile number
   */
  async getUserByMobile(mobile) {
    try {
      const q = query(
        collection(db, USERS_COLLECTION),
        where('mobile', '==', mobile)
      );
      const querySnapshot = await getDocs(q);
      
      if (!querySnapshot.empty) {
        const doc = querySnapshot.docs[0];
        return { ...doc.data(), id: doc.id };
      }
      return null;
    } catch (error) {
      console.error('Error getting user by mobile:', error);
      throw error;
    }
  },

  /**
   * Update user verification status
   */
  async verifyUser(userId) {
    try {
      const userRef = doc(db, USERS_COLLECTION, userId);
      await updateDoc(userRef, {
        isVerified: true,
        verificationDate: serverTimestamp()
      });
      return { success: true };
    } catch (error) {
      console.error('Error verifying user:', error);
      throw error;
    }
  },

  /**
   * Update user roles
   */
  async updateUserRoles(userId, roles) {
    try {
      const userRef = doc(db, USERS_COLLECTION, userId);
      await updateDoc(userRef, {
        roles,
        updatedAt: serverTimestamp()
      });
      return { success: true };
    } catch (error) {
      console.error('Error updating user roles:', error);
      throw error;
    }
  }
};